import database from "../../../services/database";
import React from "react";
import SEO from "../../../components/SEO";

function Home() {
    return (
        <>
            <SEO 
                title="Fisioterapia"
                description="Equipamentos e produtos para fisioterapia. Oferecemos soluções completas para profissionais e clínicas de fisioterapia."
                keywords="fisioterapia, equipamentos fisioterapia, produtos fisioterapia, clínica fisioterapia"
                canonicalUrl="https://www.saojoseortopedicos.com.br/produtos/fisioterapia"
            />
            <h2>{database.fisioterapia.title}</h2>
            {
                database.fisioterapia.items.map(x => {
                    return (
                        <>
                            <h3>{x.title}</h3>
                            <p>{x.description}</p>
                            <div className="images">
                                {
                                    x.images.map(y => {
                                        return (
                                            <img className="image" src={y.url} alt={y.legend} />
                                        );
                                    })
                                }
                            </div>
                        </>
                    );
                })
            }
        </>
    );
}

export default Home;